module.exports = __webpack_public_path__ + "img/ai-agent-desktop.8c8cd2b7.svg";